import React from 'react'
import { Container, Row, Col, Card, Button, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useCommunities } from '../hooks/useCommunities'

function Dashboard() {
  const { t } = useTranslation()
  const { data: communities = [], isLoading } = useCommunities();

  const activeCommunities = communities.filter(
    c => (c.metadata?.status || 'setup') === 'active'
  ).length;
  const setupCommunities = communities.filter(
    c => (c.metadata?.status || 'setup') === 'setup'
  ).length;

  return (
    <>
    <Container>
      <Row className="mb-4">
        <Col>
          <h1 style={{ color: 'var(--color-primary-dark)' }}>{t('dashboard.title')}</h1>
          <p className="text-secondary">
            {t('dashboard.welcome')}
          </p>
        </Col>
      </Row>

      {/* Stats Row */}
      <Row className="mb-4">
        <Col md={4} className="mb-3">
          <Card className="h-100 shadow-sm text-center" style={{ borderTop: '3px solid var(--color-primary)' }}>
            <Card.Body>
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <h2 style={{ color: 'var(--color-primary)' }}>{communities.length}</h2>
              )}
              <div className="text-muted">{t('dashboard.total_communities')}</div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card className="h-100 shadow-sm text-center" style={{ borderTop: '3px solid #28a745' }}>
            <Card.Body>
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <h2 style={{ color: '#28a745' }}>{activeCommunities}</h2>
              )}
              <div className="text-muted">{t('dashboard.active')}</div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card className="h-100 shadow-sm text-center" style={{ borderTop: '3px solid #ffc107' }}>
            <Card.Body>
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <h2 style={{ color: '#ffc107' }}>{setupCommunities}</h2>
              )}
              <div className="text-muted">{t('dashboard.in_setup')}</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={6} lg={4} className="mb-4">
          <Card className="h-100 shadow-sm" style={{ borderTop: '4px solid #8CB808' }}>
            <Card.Body className="d-flex flex-column">
              <Card.Title style={{ color: '#4A4A4A', fontWeight: 600 }}>
                {t('dashboard.communities_card_title')}
              </Card.Title>
              <Card.Text className="flex-grow-1">
                {t('dashboard.communities_card_text')}
              </Card.Text>
              <Button
                as={Link}
                to="/communities"
                className="mt-2"
                style={{
                  backgroundColor: '#8CB808',
                  borderColor: '#8CB808',
                  color: 'white',
                  fontWeight: 500
                }}
              >
                {t('dashboard.manage_communities')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={4} className="mb-4">
          <Card className="h-100 shadow-sm" style={{ borderTop: '4px solid #0277BD' }}>
            <Card.Body className="d-flex flex-column">
              <Card.Title style={{ color: '#4A4A4A', fontWeight: 600 }}>
                {t('dashboard.quick_start_title')}
              </Card.Title>
              <Card.Text className="flex-grow-1">
                {t('dashboard.quick_start_text')}
              </Card.Text>
              <Button
                as={Link}
                to="/communities/new"
                className="mt-2"
                style={{
                  backgroundColor: '#0277BD',
                  borderColor: '#0277BD',
                  color: 'white',
                  fontWeight: 500
                }}
              >
                {t('dashboard.create_community')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={4} className="mb-4">
          <Card className="h-100 shadow-sm" style={{ borderTop: '4px solid #5C5C5C' }}>
            <Card.Body className="d-flex flex-column">
              <Card.Title style={{ color: '#4A4A4A', fontWeight: 600 }}>
                {t('dashboard.docs_title')}
              </Card.Title>
              <Card.Text className="flex-grow-1">
                {t('dashboard.docs_text')}
              </Card.Text>
              <Button
                as={Link}
                to="/documentation"
                className="mt-2"
                style={{
                  backgroundColor: '#5C5C5C',
                  borderColor: '#5C5C5C',
                  color: 'white',
                  fontWeight: 500
                }}
              >
                {t('dashboard.view_docs')}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

    </Container>
    <a
      href="https://ecoempower.eu/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        backgroundColor: '#8CB808',
        color: '#fff',
        fontSize: '0.75rem',
        fontWeight: 600,
        padding: '8px 14px',
        borderRadius: 20,
        textDecoration: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        zIndex: 9999,
        opacity: 0.85,
      }}
      onMouseEnter={e => e.currentTarget.style.opacity = '1'}
      onMouseLeave={e => e.currentTarget.style.opacity = '0.85'}
    >
      ecoempower.eu
    </a>
    </>
  )
}

export default Dashboard
